import '../public/fonts/iconfont-generated.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserTracing } from '@sentry/tracing';
import generatedGitInfo from './generatedGitInfo.json';

const DEBUG = process.env.DEBUG === 'true';

// Initialize Sentry for error tracking only if DEBUG is true
if (DEBUG) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    environment: 'production',
    release: 'hubs101 We-website App@' + generatedGitInfo.gitBranch,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const AppTree = DEBUG ? (
  <Sentry.ErrorBoundary
    fallback={<p>Something went wrong (sentry error boundary)</p>}
  >
    <App />
  </Sentry.ErrorBoundary>
) : (
  <App />
);

root.render(<React.StrictMode>{AppTree}</React.StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.log);
